import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectSelectedComponent, updateComponent } from '../../../redux/editorSlice';
import { SkinSelector } from '../CommonProperties';
import { usePropertyPanel } from '../PropertyPanelContext';

const OrderHistoryProperties = () => {
  const selectedComponent = useSelector(selectSelectedComponent);
  const dispatch = useDispatch();
  const { handleComponentPropsChange } = usePropertyPanel();
  
  return (
    <>
      {/* 스킨 선택 */}
      <SkinSelector
        selectedComponent={selectedComponent}
        onSkinChange={(skinId) => handleComponentPropsChange('skin', skinId)}
      />

      {/* 주문 내역 설정 */}
      <div className="property-group">
        <div className="property-group-title">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 11H4a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h5a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M20 11h-5a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h5a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M9 11V7a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          주문 내역 설정
        </div>
        
        <div className="property-row">
          <label style={{ minWidth: '30%' }}>제목</label>
          <input 
            type="text"
            value={selectedComponent.componentProps?.title || '주문 내역'}
            onChange={(e) => handleComponentPropsChange('title', e.target.value)}
            style={{ width: '100%' }}
          />
        </div>
        
        <div className="property-row">
          <label style={{ minWidth: '30%' }}>빈 목록 메시지</label>
          <input 
            type="text"
            value={selectedComponent.componentProps?.emptyText || '주문 내역이 없습니다.'}
            onChange={(e) => handleComponentPropsChange('emptyText', e.target.value)}
            style={{ width: '100%' }}
          />
        </div>
        
        <div className="property-row">
          <label style={{ minWidth: '30%' }}>페이지당 항목 수</label>
          <input 
            type="number"
            min="5"
            max="50"
            value={selectedComponent.componentProps?.itemsPerPage || 10}
            onChange={(e) => handleComponentPropsChange('itemsPerPage', parseInt(e.target.value) || 10)}
            style={{ width: '100%' }}
          />
        </div>
      </div>

      {/* 표시 옵션 설정 */}
      <div className="property-group">
        <div className="property-group-title">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2L2 7V17L12 22L22 17V7L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          표시 옵션
        </div>
        
        <div className="property-row">
          <label style={{ minWidth: '30%' }}>검색 기능</label>
          <div className="custom-toggle-switch">
            <input 
              id="toggle-search"
              type="checkbox" 
              checked={selectedComponent.componentProps?.showSearch !== false}
              onChange={(e) => handleComponentPropsChange('showSearch', e.target.checked)}
            />
            <label htmlFor="toggle-search" className="toggle-switch-label">
              <span className="toggle-track"></span>
            </label>
          </div>
        </div>
        
        <div className="property-row">
          <label style={{ minWidth: '30%' }}>필터 기능</label>
          <div className="custom-toggle-switch">
            <input 
              id="toggle-filter"
              type="checkbox" 
              checked={selectedComponent.componentProps?.showFilter !== false}
              onChange={(e) => handleComponentPropsChange('showFilter', e.target.checked)}
            />
            <label htmlFor="toggle-filter" className="toggle-switch-label">
              <span className="toggle-track"></span>
            </label>
          </div>
        </div>
        
        <div className="property-row">
          <label style={{ minWidth: '30%' }}>페이지네이션</label>
          <div className="custom-toggle-switch">
            <input 
              id="toggle-pagination"
              type="checkbox" 
              checked={selectedComponent.componentProps?.showPagination !== false}
              onChange={(e) => handleComponentPropsChange('showPagination', e.target.checked)}
            />
            <label htmlFor="toggle-pagination" className="toggle-switch-label">
              <span className="toggle-track"></span>
            </label>
          </div>
        </div>
        
        <div className="property-row">
          <label style={{ minWidth: '30%' }}>주문 상세 버튼</label>
          <div className="custom-toggle-switch">
            <input 
              id="toggle-order-detail"
              type="checkbox" 
              checked={selectedComponent.componentProps?.showOrderDetail !== false}
              onChange={(e) => handleComponentPropsChange('showOrderDetail', e.target.checked)}
            />
            <label htmlFor="toggle-order-detail" className="toggle-switch-label">
              <span className="toggle-track"></span>
            </label>
          </div>
        </div>
        
        <div className="property-row">
          <label style={{ minWidth: '30%' }}>주문 취소 버튼</label>
          <div className="custom-toggle-switch">
            <input 
              id="toggle-cancel-button"
              type="checkbox" 
              checked={selectedComponent.componentProps?.showCancelButton !== false}
              onChange={(e) => handleComponentPropsChange('showCancelButton', e.target.checked)}
            />
            <label htmlFor="toggle-cancel-button" className="toggle-switch-label">
              <span className="toggle-track"></span>
            </label>
          </div>
        </div>
        
        <div className="property-row">
          <label style={{ minWidth: '30%' }}>배송 추적 버튼</label>
          <div className="custom-toggle-switch">
            <input 
              id="toggle-tracking-button"
              type="checkbox" 
              checked={selectedComponent.componentProps?.showTrackingButton !== false}
              onChange={(e) => handleComponentPropsChange('showTrackingButton', e.target.checked)}
            />
            <label htmlFor="toggle-tracking-button" className="toggle-switch-label">
              <span className="toggle-track"></span>
            </label>
          </div>
        </div>
      </div>

      {/* 스타일 설정 */}
      <div className="property-group">
        <div className="property-group-title">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2L2 7V17L12 22L22 17V7L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          스타일 설정
        </div>
        
        <div className="property-row">
          <label>주요 버튼 색상</label>
          <input 
            type="color" 
            value={selectedComponent.componentProps?.primaryButtonColor || '#007bff'}
            onChange={(e) => handleComponentPropsChange('primaryButtonColor', e.target.value)}
            style={{ width: '100%', height: '32px' }}
          />
        </div>
        
        <div className="property-row">
          <label>보조 버튼 색상</label>
          <input 
            type="color" 
            value={selectedComponent.componentProps?.secondaryButtonColor || '#6c757d'}
            onChange={(e) => handleComponentPropsChange('secondaryButtonColor', e.target.value)}
            style={{ width: '100%', height: '32px' }}
          />
        </div>
        
        <div className="property-row">
          <label>취소 버튼 색상</label>
          <input 
            type="color" 
            value={selectedComponent.componentProps?.dangerButtonColor || '#dc3545'}
            onChange={(e) => handleComponentPropsChange('dangerButtonColor', e.target.value)}
            style={{ width: '100%', height: '32px' }}
          />
        </div>
      </div>

      {/* 주문 상태 색상 설정 */}
      <div className="property-group">
        <div className="property-group-title">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
            <path d="M12 6v6l4 2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          </svg>
          주문 상태 색상
        </div>
        
        <div className="property-row">
          <label>결제 대기</label>
          <input 
            type="color" 
            value={selectedComponent.componentProps?.statusColors?.pending || '#ffc107'}
            onChange={(e) => {
              const statusColors = { ...(selectedComponent.componentProps?.statusColors || {}) };
              statusColors.pending = e.target.value;
              handleComponentPropsChange('statusColors', statusColors);
            }}
            style={{ width: '100%', height: '32px' }}
          />
        </div>
        
        <div className="property-row">
          <label>처리중</label>
          <input 
            type="color" 
            value={selectedComponent.componentProps?.statusColors?.processing || '#17a2b8'}
            onChange={(e) => {
              const statusColors = { ...(selectedComponent.componentProps?.statusColors || {}) };
              statusColors.processing = e.target.value;
              handleComponentPropsChange('statusColors', statusColors);
            }}
            style={{ width: '100%', height: '32px' }}
          />
        </div>
        
        <div className="property-row">
          <label>배송중</label>
          <input 
            type="color" 
            value={selectedComponent.componentProps?.statusColors?.shipped || '#007bff'}
            onChange={(e) => {
              const statusColors = { ...(selectedComponent.componentProps?.statusColors || {}) };
              statusColors.shipped = e.target.value;
              handleComponentPropsChange('statusColors', statusColors);
            }}
            style={{ width: '100%', height: '32px' }}
          />
        </div>
        
        <div className="property-row">
          <label>배송완료</label>
          <input 
            type="color" 
            value={selectedComponent.componentProps?.statusColors?.delivered || '#28a745'}
            onChange={(e) => {
              const statusColors = { ...(selectedComponent.componentProps?.statusColors || {}) };
              statusColors.delivered = e.target.value;
              handleComponentPropsChange('statusColors', statusColors);
            }}
            style={{ width: '100%', height: '32px' }}
          />
        </div>
        
        <div className="property-row">
          <label>취소됨</label>
          <input 
            type="color" 
            value={selectedComponent.componentProps?.statusColors?.cancelled || '#dc3545'}
            onChange={(e) => {
              const statusColors = { ...(selectedComponent.componentProps?.statusColors || {}) };
              statusColors.cancelled = e.target.value;
              handleComponentPropsChange('statusColors', statusColors);
            }}
            style={{ width: '100%', height: '32px' }}
          />
        </div>
        
        <div className="property-row">
          <label>환불됨</label>
          <input 
            type="color" 
            value={selectedComponent.componentProps?.statusColors?.refunded || '#6c757d'}
            onChange={(e) => {
              const statusColors = { ...(selectedComponent.componentProps?.statusColors || {}) };
              statusColors.refunded = e.target.value;
              handleComponentPropsChange('statusColors', statusColors);
            }}
            style={{ width: '100%', height: '32px' }}
          />
        </div>
      </div>
    </>
  );
};

export default OrderHistoryProperties;